import { MatrixCellInterface } from "@swivl-mono/types";
import * as React from "react";
import { FaPlusCircle } from "react-icons/fa";

import MatrixView from "../../MatrixView";
import "./MatrixAddColumnOrRow.scss";

interface Props {
  delegate: MatrixView;
  item: MatrixCellInterface;
  focus: { x: any; y: any };
  x: number;
  y: number;
}
export default class MatrixAddColumnOrRow extends React.Component<Props> {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }
  onClick() {
    this.props.delegate.addColumnOrRow(this.props.item.direction);
  }

  render() {
    const className =
      this.props.focus && this.props.focus.x === this.props.x && this.props.focus.y === this.props.y
        ? "MatrixAddColumnOrRow focused"
        : "MatrixAddColumnOrRow";
    return (
      <div className={className} onClick={this.onClick}>
        <FaPlusCircle />
      </div>
    );
  }
}
